export default function(id) {
  let ref = "file_" + id;
  this.$refs[ref][0].click();
}
